import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './app-router';
import NotificationToast from './components/NotificationToast';
import { useCustomNotificationToast } from './hooks/useCustomNotificationToast';
import { setGlobalNotificationToast } from './utils/globalNotificationToast';

const queryClient = new QueryClient();

function App() {
  const notificationToast = useCustomNotificationToast();
  React.useEffect(() => {
    setGlobalNotificationToast(notificationToast);
  }, [notificationToast]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        future={{
          v7_startTransition: true
        }}
      />
      {/* Custom Notification Toast for FCM */}
      <NotificationToast
        notification={notificationToast.notification}
        onClose={notificationToast.hideNotification}
      />
    </QueryClientProvider>
  );
}

export default App;
